import React, { useState, useEffect } from 'react';
import { Redirect, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import LoginPage from '../../Login/LoginPage';
import RegisterNewMemberPage from '../../Login/Register/RegisterNewMemberPage'
import RegisterSuccessPage from '../../Login/Register/RegisterSuccessPage'

import PublicIndividual from "./Individual";
import InternalMain from '../../Internal/Main/Main'
import Firm from "./Firm";
import Enums from '../../../helpers/enums';

import AuthService from "../../../services/auth.service";
import ForgotPassword from '../../Login/ForgotPassword';
import ForgotPasswordSuccess from '../../Login/ForgotPasswordSuccess';
import ForgotUserId from '../../Login/ForgotUserId';
import ForgotUserIdSuccess from '../../Login/ForgotUserIdSuccess';
import SwitchAccountPage from '../../Shared/AccountSwitcher/SwitchAccountPage';

export default function Main() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [isBoardMember, setIsBoardMember] = useState(false);
    const [userType, setUserType] = useState(null);
    const history = useNavigate();
    const location = useLocation();
    const handleLogin = (loggedIn) => {
        setLoggedIn(loggedIn);
        if (loggedIn === true) {
            //get user data and send to appropriate page
            var roles = AuthService.getRoles();
            if (roles.includes("Admin")) {
                setUserType(Enums.userRoles.ADMINISTRATOR);
                if (pathContains("login")) {
                    history("/internal");
                }
                //Todo: push history
            }
            else if (roles.includes("Staff")) {
                setUserType(Enums.userRoles.STAFF);
                if (pathContains("login")) {
                    history("/internal");
                }
                //Todo: push history
            }
            else if (roles.includes("Firm")) {
                setUserType(Enums.userRoles.FIRM);
                if (!pathContains("firm")) {
                    history("/firm");
                }
            }
            else if (roles.includes("Individual")) {
                if (roles.includes("Board")) {
                    setIsBoardMember(true);
                    var currentlyLoggedOnUser = location.pathname.split("/")[1] == "";
                    if (pathContains("login") || currentlyLoggedOnUser) {
                        history("/individual/boardApprovals");
                    }
                }
                setUserType(Enums.userRoles.INDIVIDUAL);
                if (!pathContains("individual")) {
                    history("/individual");
                }
            }
            else {
                sendToLogin();
            }

        } else {
            sendToLogin();
        }
    }
    const sendToLogin = () => {
        setUserType(null);
        setLoggedIn(false);

        localStorage.removeItem('updateRecentQueue');
        localStorage.removeItem('updateRecentContacts');
        localStorage.removeItem('currentPageCache');
        localStorage.removeItem('searchCache');
        localStorage.removeItem('displayLengthCache');
        //debugger;
        if (!pathContains("login")) {
            history("/login");
        }
    }

    const pathContains = (name) => {
        var pathArray = location.pathname.split("/");
        return pathArray[1] && pathArray[1] === name;
    };
    const isAddingAccount = new URLSearchParams(location.search).get("addAccount") === "1";
    const isSwitchAccountPage = pathContains("switchAccount");
    useEffect(() => {
        //this will force the login page to load along with its routes
        //but doing this ruins the history....
        if (isSwitchAccountPage) {
            // this page lives outside the app shell, like the login pages - leave
            // loggedIn/userType alone so it renders regardless of session state
            return;
        }
        var user = AuthService.getCurrentUser();
        if (user !== null && !isAddingAccount) {
            handleLogin(true);
        }
        else {
            handleLogin(false);
        }
    }, []);

    return (
        <div>
            {isSwitchAccountPage ? <SwitchAccountPage /> :
                userType === Enums.userRoles.ADMINISTRATOR ? <InternalMain /> :
                        userType === Enums.userRoles.STAFF ? <InternalMain /> :
                userType === Enums.userRoles.FIRM ? <Firm /> :
                    userType === Enums.userRoles.INDIVIDUAL ? <PublicIndividual isBoardMember={isBoardMember} /> :
                            <>
                                <Routes>
                                    <Route path="/" element={<LoginPage handleLogin={handleLogin} addAccountMode={isAddingAccount} />} exact />
                                    <Route path="/login" element={<LoginPage handleLogin={handleLogin} addAccountMode={isAddingAccount} />} exact />
                                    <Route path="/register" element={<RegisterNewMemberPage />} />
                                    <Route path="/forgotpassword" element={<ForgotPassword />} />
                                    <Route path="/forgotpasswordsuccess" element={<ForgotPasswordSuccess />} />
                                    <Route path="/registersuccess" element={<RegisterSuccessPage />} />
                                    <Route path="/forgotuserid" element={<ForgotUserId />} />
                                    <Route path="/forgotuseridsuccess" element={<ForgotUserIdSuccess />} />
                                </Routes>
                            </>
            }
        </div>
    )
}